import React from 'react';
import styled from 'styled-components';
import cal_left from '../../images/cal_left.png'
import cal_right from '../../images/cal_right.png'
import DayPicker from 'react-day-picker';
// Or import the input component
import 'react-day-picker/lib/style.css';






// const MONTHS = [
//     '1월',
//     '2월',
//     '3월',
//     '4월',
//     '5월',
//     '6월',
//     '7월',
//     '8월',
//     '9월',
//     '10월',
//     '11월',
//     '12월',
//   ];
  const WEEKDAYS_SHORT = ['일', '월', '화', '수', '목', '금', '토'];

  function YearMonthForm({ date, }) {
  
    return (
      <div className="DayPicker-Caption">
        <div name="year">
          {date.getFullYear()}
        </div>
        <div name="month">
          {date.getMonth()+1+"월"}
        </div>
      </div>
    );
  }

export default class Calendar extends React.Component {

    constructor(props) {
        super(props);
        this.handleDayClick = this.handleDayClick.bind(this);
        this.state = {
          selectedDay: undefined,
        };
      }
    
      handleDayClick(day, { selected,disabled }) {
        if (selected) {
          // 이미 선택한 경우 날짜 선택 취소
          this.setState({ selectedDay: undefined });
          return;
        }
        this.props.setSelectDay(day.toLocaleDateString());
        this.props.setSubmitDay(day);
        this.props.setUnselectDay(true);
        this.setState({ selectedDay: day });
        if (disabled ) {
            this.setState({ selectedDay: undefined });
            this.props.setUnselectDay(false);
        }
      }



    

        render() {
            const todaycolorStyle = `.DayPicker-Day--today {
                color: #4e4e4e !important;
            }`;
            const todayStyle = `.DayPicker-Day--highlighted::after {
                content: '';
                background-color: #ffcf19;
                color: #4e4e4e;
                width: calc(100vw*(25/375));
                height: calc(100vw*(25/375));
                position: absolute;
                border-radius: 50%;
                top: 50%;
                left: 50%;
                z-index: -1;
                transform: translate(-50%, -50%);
            }`;
            const selectedStyle = `.DayPicker-Day--selected:not(.DayPicker-Day--disabled):not(.DayPicker-Day--outside) {
                position: relative;
                color: #121212;
                z-index: 2;
                background: transparent;
            }`;
            const selectedAterStyle = `.DayPicker-Day--selected:not(.DayPicker-Day--disabled):not(.DayPicker-Day--outside)::after {
                    content: '';
                    background-color: #eaeaea;
                    color: white;
                    width: calc(100vw*(27/375));
                    height: calc(100vw*(27/375));
                    position: absolute;
                    border-radius: 50%;
                    top: 50%;
                    left: 50%;
                    z-index: -1;
                    transform: translate(-50%, -50%); 
            }`;
            const selectedHoverStyle2 = `.DayPicker-Day--selected:not(.DayPicker-Day--disabled):not(.DayPicker-Day--outside):hover {
                background-color: transparent;
            }`;
            const selectedHoverStyle = `.DayPicker:not(.DayPicker--interactionDisabled) .DayPicker-Day:not(.DayPicker-Day--disabled):not(.DayPicker-Day--selected):not(.DayPicker-Day--outside):hover {
                background-color: transparent ;
            }`;
            const modifiers = {
                highlighted: new Date(),
            };
            const past = { 
                before: new Date(),
            }
        return (
            <div>
                <Calendararea >
                    <style>
                        {todaycolorStyle}
                        {todayStyle}
                        {selectedStyle}
                        {selectedAterStyle}
                        {selectedHoverStyle}
                        {selectedHoverStyle2}
                    </style>
                    <DayPicker
                        disabledDays={past}
                        modifiers={modifiers}
                        onDayClick={this.handleDayClick} 
                        selectedDays={this.state.selectedDay}
                        // months={MONTHS}
                        weekdaysShort={WEEKDAYS_SHORT}
                        captionElement={({ date, localeUtils }) => (
                            <YearMonthForm
                              date={date}
                              localeUtils={localeUtils}
                              onChange={this.handleYearMonthChange}
                            />
                          )}
                    />

{/*                 
                    {this.state.selectedDay ?
                        (<p> {this.state.selectedDay.toLocaleDateString()}</p>)
                    : 
                        (<p>날짜를 선택해줘용</p>)
                    } */}
                
                </Calendararea>
     

   
            </div>
        )
    }
}

const Calendararea = styled.div`
    padding: 0 calc(100vw*(17/375)) 0 calc(100vw*(15/375));
    background : #fff;
    & .DayPicker {
        width : 100%;
    }
    & .DayPicker-Day--today {
        color : #fff;
        position: relative;
        z-index: 2;
        font-weight: 500;
    }
    & .DayPicker-Day {
        font-size: calc(100vw*(11/375));
        font-weight: 500;
        padding: .9em 1.6em;
    }
    & .DayPicker-wrapper {
        padding-bottom :calc(100vw*(5/375));
    }
    & .DayPicker-Month {
        margin : 0;
    }
    & .DayPicker-NavButton--next {
        position: absolute;
        top: calc(100vw*(8/375));
        right: calc(100vw*(115/375));
        width: calc(100vw*(7/375));
        height: calc(100vw*(12/375));
        background-image : url(${cal_right});
        background-repeat: no-repeat;
        background-size : calc(100vw*(7/375)) calc(100vw*(12/375));
    }
    & .DayPicker-NavButton--prev {
        position: absolute;
        top: calc(100vw*(8/375));
        left: calc(100vw*(115/375));
        width: calc(100vw*(7/375));
        height: calc(100vw*(12/375));
        background-image : url(${cal_left});
        background-repeat: no-repeat;
        background-size : calc(100vw*(7/375)) calc(100vw*(12/375));
    }
    & .DayPicker-Caption {
        margin-bottom:  calc(100vw*(12/375));
        padding: calc(100vw*(6.5/375)) 0 0 0;
        text-align: center;
    }
    & .DayPicker-Caption > div {
        text-align: center;
        font-size: calc(100vw*(14/375));
        font-weight: 500;
        display: inline-block;
    }
    & .DayPicker-Caption > div:first-child {
        margin-right: calc(100vw*(3/375));
    }
    & .DayPicker-Body > div:first-child > div {
        padding: 0.2em 1em .9em 1em;
        &::after {
            top:40%;
        }
    }
    & .DayPicker-Weekday abbr[title] {
        font-size: calc(100vw*(10/375));
        font-weight: 500;
        color: #ffc036;
    }

`
